import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('tk_token'));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const data = await api('/api/auth/me', { token });
      setUser(data.user);
    } catch {
      setToken(null);
      localStorage.removeItem('tk_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (username, password, captchaToken = '') => {
    const data = await api('/api/auth/login', {
      method: 'POST',
      body: { username, password, captchaToken },
    });
    localStorage.setItem('tk_token', data.token);
    setToken(data.token);
    setUser(data.user);
  };

  const register = async (username, password, captchaToken = '') => {
    const data = await api('/api/auth/register', {
      method: 'POST',
      body: { username, password, captchaToken },
    });
    localStorage.setItem('tk_token', data.token);
    setToken(data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem('tk_token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
